import { LitElement, html, css } from 'lit';

class MetalyxFooter extends LitElement {
  static styles = css`
    :host {
      display: block;
    }

    footer {
      padding: 3rem var(--space-container, 1.5rem) 2rem;
      border-top: 1px solid var(--color-border, rgba(255,255,255,0.06));
    }

    .container {
      max-width: var(--max-width, 1200px);
      margin: 0 auto;
    }

    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 2rem;
      flex-wrap: wrap;
      gap: 1.5rem;
    }

    .logo {
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      text-decoration: none;
    }
    .logo-text {
      font-family: var(--font-heading, 'Outfit', sans-serif);
      font-size: var(--text-xl, 1.25rem);
      font-weight: 800;
      color: var(--color-text-heading, #fff);
      letter-spacing: 0.08em;
    }

    .links {
      display: flex;
      align-items: center;
      gap: 2rem;
      list-style: none;
      margin: 0;
      padding: 0;
    }
    .links a {
      font-family: var(--font-sans, sans-serif);
      font-size: var(--text-sm, 0.875rem);
      color: var(--color-text-muted, #64748B);
      text-decoration: none;
      transition: color var(--transition, 200ms ease);
    }
    .links a:hover {
      color: var(--color-text-heading, #fff);
    }

    .socials {
      display: flex;
      align-items: center;
      gap: 1rem;
    }
    .socials a {
      color: var(--color-text-muted, #64748B);
      transition: color var(--transition, 200ms ease);
      display: inline-flex;
    }
    .socials a:hover {
      color: var(--color-accent, #7C3AED);
    }

    .bottom {
      padding-top: 1.5rem;
      border-top: 1px solid var(--color-border, rgba(255,255,255,0.06));
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      gap: 1rem;
    }

    .copyright {
      font-size: var(--text-sm, 0.875rem);
      color: var(--color-text-muted, #64748B);
    }

    .tagline {
      font-family: var(--font-mono, 'Space Mono', monospace);
      font-size: var(--text-xs, 0.75rem);
      color: var(--color-text-muted, #64748B);
      opacity: 0.6;
      letter-spacing: 0.1em;
    }

    @media (max-width: 640px) {
      .top {
        flex-direction: column;
        align-items: flex-start;
      }
      .bottom {
        flex-direction: column;
        align-items: flex-start;
      }
    }
  `;

  _openContact(e) {
    e.preventDefault();
    window.dispatchEvent(new CustomEvent('open-contact'));
  }

  render() {
    return html`
      <footer>
        <div class="container">
          <div class="top">
            <a class="logo" href="#">
              <span class="logo-text">METALYX</span>
            </a>
            <ul class="links">
              <li><a href="#">Platform</a></li>
              <li><a href="#" @click="${this._openContact}">Contact</a></li>
            </ul>
            <div class="socials">
              <a href="https://linkedin.com" target="_blank" rel="noopener" aria-label="LinkedIn">
                <metalyx-icon name="linkedin" size="20"></metalyx-icon>
              </a>
            </div>
          </div>
          <div class="bottom">
            <span class="copyright">&copy; 2026 Metalyx. All rights reserved.</span>
            <span class="tagline">Data Science for Mining & Minerals</span>
          </div>
        </div>
      </footer>
    `;
  }
}

customElements.define('metalyx-footer', MetalyxFooter);